module.exports = __webpack_public_path__ + "static/media/loader2.aabee301.gif";